import React, { memo } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useBreakpoint } from '../../Context/BreakpointContext';

const propTypes = {
  filterByAsset: PropTypes.string,
  filterByLabel: PropTypes.string,
  filterByOrg: PropTypes.string,
  filterByReminder: PropTypes.string,
  filterByStatus: PropTypes.string,
  handleClearFilters: PropTypes.func,
  handleDropdownFilter: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  showMobileFilters: PropTypes.bool,
  toggleMobileFilters: PropTypes.func,
};
const defaultProps = {
  filterByAsset: '',
  filterByLabel: '',
  filterByOrg: '',
  filterByReminder: '',
  filterByStatus: '',
  handleClearFilters: () => {},
  handleDropdownFilter: () => {},
  handleSearchFilter: () => {},
  showMobileFilters: false,
  toggleMobileFilters: () => {},
};

const ServiceTableMobileFilters = ({
  filterByAsset,
  filterByLabel,
  filterByOrg,
  filterByReminder,
  filterByStatus,
  handleClearFilters,
  handleDropdownFilter,
  handleSearchFilter,
  showMobileFilters: isOpen,
  toggleMobileFilters: toggleModal,
}) => {
  const { smMobile } = useBreakpoint();
  const statusOptions = [
    { display: 'Due', value: 'due' },
    { display: 'Upcoming', value: 'upcoming' },
    { display: 'All', value: '' },
  ];
  const statusDisplay = new Map([
    ['due', 'Due'],
    ['upcoming', 'Upcoming'],
    ['', 'All'],
  ]);
  const labelOptions = [
    { display: 'Inspection', value: 'Inspection' },
    { display: 'Maintenance', value: 'Maintenance' },
    { display: 'Parts', value: 'Parts' },
    { display: 'Sales', value: 'Sales' },
    { display: 'Service', value: 'Service' },
    { display: 'Warranty', value: 'Warranty' },
    { display: 'All', value: '' },
  ];
  const labelDisplay = new Map([
    ['Inspection', 'Inspection'],
    ['Maintenance', 'Maintenance'],
    ['Parts', 'Parts'],
    ['Sales', 'Sales'],
    ['Service', 'Service'],
    ['Warranty', 'Warranty'],
    ['', 'Label'],
  ]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleModal(false)}
      className={className}
      contentClassName={`border-0 shadow ${
        smMobile ? 'h-75 overflow-auto' : ''
      }`}
      backdropClassName="bg-transparent"
    >
      <ModalHeader
        toggle={() => toggleModal(false)}
        className="border-bottom-0"
      >
        <p className="font-weight-normal">Filters</p>
      </ModalHeader>

      <ModalBody className="container-fluid pt-2">
        <div className="row">
          <div className="col form-group">
            <label
              htmlFor="status"
              className="three-quarter-text text-text-gray"
            >
              Status
            </label>
            <div className="dropdown">
              <button
                className="btn btn-sm btn-outline-third-gray w-100 dropdown-toggle d-flex align-items-center justify-content-between text-text-gray"
                type="button"
                id="mobileStatusSelectMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                name="status"
              >
                <span className="text-capitalize three-quarter-text">
                  {statusDisplay.get(filterByStatus)}
                </span>
              </button>
              <div
                className="dropdown-menu w-100 rounded-lg shadow"
                aria-labelledby="mobileStatusSelectMenuButton"
              >
                {statusOptions.map(({ display, value }) => (
                  <button
                    key={`status_${value}`}
                    className={`dropdown-item px-3 three-quarter-text ${
                      value === filterByStatus ? '' : 'text-text-light-gray'
                    }`}
                    onClick={() => handleDropdownFilter(value, 'status')}
                  >
                    {display}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col form-group">
            <label
              htmlFor="asset"
              className="three-quarter-text text-text-gray"
            >
              Asset
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control form-control-sm three-quarter-text"
                placeholder="Asset"
                value={filterByAsset}
                name="asset"
                onChange={handleSearchFilter}
                aria-describedby="mobileAssetSearchCaret"
              />
              <div className="input-group-append">
                <span
                  className="input-group-text bg-white"
                  id="mobileAssetSearchCaret"
                >
                  <FontAwesomeIcon
                    className="text-text-light-gray"
                    icon={faSearch}
                    size="xs"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col form-group">
            <label
              htmlFor="organization"
              className="three-quarter-text text-text-gray"
            >
              Org
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control form-control-sm three-quarter-text"
                placeholder="Organization"
                value={filterByOrg}
                name="organization"
                onChange={handleSearchFilter}
                aria-describedby="mobileAssetSearchCaret"
              />
              <div className="input-group-append">
                <span
                  className="input-group-text bg-white"
                  id="mobileAssetSearchCaret"
                >
                  <FontAwesomeIcon
                    className="text-text-light-gray"
                    icon={faSearch}
                    size="xs"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col form-group">
            <label
              htmlFor="reminder"
              className="three-quarter-text text-text-gray"
            >
              Reminder
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control form-control-sm three-quarter-text"
                placeholder="Reminder"
                value={filterByReminder}
                name="reminder"
                onChange={handleSearchFilter}
                aria-describedby="mobileAssetSearchCaret"
              />
              <div className="input-group-append">
                <span
                  className="input-group-text bg-white"
                  id="mobileAssetSearchCaret"
                >
                  <FontAwesomeIcon
                    className="text-text-light-gray"
                    icon={faSearch}
                    size="xs"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col form-group">
            <label
              htmlFor="label"
              className="three-quarter-text text-text-gray"
            >
              Label
            </label>
            <div className="dropdown">
              <button
                className="btn btn-sm btn-outline-third-gray w-100 dropdown-toggle d-flex align-items-center justify-content-between text-text-gray"
                type="button"
                id="mobileStatusSelectMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                name="label"
              >
                <span className="text-capitalize three-quarter-text">
                  {labelDisplay.get(filterByLabel)}
                </span>
              </button>
              <div
                className="dropdown-menu w-100 rounded-lg shadow"
                aria-labelledby="mobileStatusSelectMenuButton"
              >
                {labelOptions.map(({ display, value }) => (
                  <button
                    key={`label_${value}`}
                    className={`dropdown-item px-3 three-quarter-text ${
                      value === filterByLabel ? '' : 'text-text-light-gray'
                    }`}
                    onClick={() => handleDropdownFilter(value, 'label')}
                  >
                    {display}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          .dropdown-toggle::after {
            margin-left: 1.5rem;
          }
          .dropdown-item {
            outline: none;
          }
          .dropdown-item:hover {
            background: transparent;
          }
        `}</style>
      </ModalBody>

      <ModalFooter className="align-items-center justify-content-center border-0">
        <div className="w-100 p-2">
          <button
            className="btn btn-sm btn-outline-third-gray text-text-gray py-0 w-100"
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>
        </div>
      </ModalFooter>
      {styles}
    </Modal>
  );
};
ServiceTableMobileFilters.propTypes = propTypes;
ServiceTableMobileFilters.defaultProps = defaultProps;

const { className, styles } = css.resolve`
  .modal-dialog {
    margin-top: 75px;
  }
`;

export default memo(ServiceTableMobileFilters);
// Exports to ./ServiceDisplay
